/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalDocumentList } from './PortalDocumentList';
import {
    PortalDocumentListFromJSON,
    PortalDocumentListFromJSONTyped,
    PortalDocumentListToJSON,
    PortalDocumentListToJSONTyped,
} from './PortalDocumentList';

/**
 * 
 * @export
 * @interface PortalDocumentListResponse
 */
export interface PortalDocumentListResponse {
    /**
     * 
     */
    data: PortalDocumentList;
}

/**
 * Check if a given object implements the PortalDocumentListResponse interface.
 */
export function instanceOfPortalDocumentListResponse(value: object): value is PortalDocumentListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalDocumentListResponseFromJSON(json: any): PortalDocumentListResponse {
    return PortalDocumentListResponseFromJSONTyped(json, false);
}

export function PortalDocumentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalDocumentListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalDocumentListFromJSON(json['data']),
    };
}

export function PortalDocumentListResponseToJSON(json: any): PortalDocumentListResponse {
    return PortalDocumentListResponseToJSONTyped(json, false);
}

export function PortalDocumentListResponseToJSONTyped(value?: PortalDocumentListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalDocumentListToJSON(value['data']),
    };
}

